export default "__VITE_ASSET__BKaqi71L__"